import Box from '@mui/material/Box';

import { LUTIQ_COLORS } from '../theme';
import { LutiqLogo } from './common/LutiqLogo';

const LoadingScreen = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      bgcolor: LUTIQ_COLORS.paper,
      '@keyframes streak1': {
        '0%, 100%': { opacity: 1 },
        '40%': { opacity: 0.25 },
      },
      '@keyframes streak2': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0.25 },
      },
      '@keyframes streak3': {
        '0%, 100%': { opacity: 1 },
        '60%': { opacity: 0.25 },
      },
      '& svg line:nth-of-type(1)': {
        animation: 'streak1 1.8s ease-in-out infinite',
      },
      '& svg line:nth-of-type(2)': {
        animation: 'streak2 1.8s ease-in-out infinite',
      },
      '& svg line:nth-of-type(3)': {
        animation: 'streak3 1.8s ease-in-out infinite',
      },
    }}
  >
    <LutiqLogo height={32} />
  </Box>
);

export default LoadingScreen;
